import * as types from '../actions/actionTypes';

import { filter, keyBy, map, pickBy } from 'lodash';
import { IjobPartPopulated, ImanagePartReducer, Ipart } from '../models';
import initialState, {
    initialJobPartPopulated,
    initialPart
} from './initialState';

import { combineReducers } from 'redux';
import { createSelector } from 'reselect';
import { IinitialState } from '.';

/**
 *************************** NORMALIZERS
 * Backend returns JobPart with materialID and Material (not partID/Part).
 * Map to partID and part for UI (EditJobForm expects part.part.id, part.part.number, etc.).
 */
export const cleanJobPart = (jobPart: any): IjobPartPopulated => {
    const material = jobPart.material || jobPart.Material;
    const materialID =
        jobPart.materialID ?? jobPart.MaterialID ?? jobPart.partID;
    const part: Ipart = material
        ? {
              ...initialPart,
              id: material.id ?? materialID,
              number: material.number ?? '',
              description: material.description ?? material.name ?? '',
              installationTime: material.installationTime ?? 0
          }
        : initialPart;
    const { materialID: _mid, Material: _M, material: _m, ...rest } = jobPart;
    return {
        ...initialJobPartPopulated,
        ...pickBy(rest, (property, key) => property !== null),
        partID: materialID ?? rest.partID ?? '',
        part
    };
};

export const cleanPart = (part: any): Ipart => {
    return {
        ...initialPart,
        ...pickBy(part, (property, key) => property !== null)
    };
};

/**
 *************************** SELECTORS
 */

// Will likely want to add a seperate reselect selector that is responsible for populating the jobPart objects with part objects
// should also be sorting.  take a look at selectPartOptions() in the mobile app

const getJobParts = (state: IinitialState) => state.managePart.jobParts;
const getSelectedJob = (state: IinitialState) => state.manageJob.selectedJob;

export const selectJobPartsForJob = createSelector(
    [getJobParts, getSelectedJob],
    (jobParts, selectedJob): IjobPartPopulated[] => {
        return filter(jobParts, { isDeleted: false, jobID: selectedJob.id });
    }
);

/**
 *********************** REDUCERS
 */

const jobPartsReducer = (
    state: { [key: string]: IjobPartPopulated } = initialState.managePart
        .jobParts,
    action: any
): { [key: string]: IjobPartPopulated } => {
    switch (action.type) {
        case types.SAVE_JOB_PARTS_SUCCESS:
        case types.GET_JOB_PARTS_SUCCESS: {
            if (Array.isArray(action.payload)) {
                const cleanedJobParts = map(action.payload, cleanJobPart);
                return { ...state, ...keyBy(cleanedJobParts, 'id') };
            }
            return state;
        }
        default:
            return state;
    }
};

const managePart = combineReducers<ImanagePartReducer>({
    jobParts: jobPartsReducer
});

export default managePart;
